const SearchReducerInitialState = {
  attraction_id: (process.env.REACT_APP_APP_ID) ? process.env.REACT_APP_APP_ID : '',
  lang: process.env.REACT_APP_DEFAULT_LANG,
  sale_cur: '',
};

export default SearchReducerInitialState;
